import { MAIN_PATH } from 'cpmMore/navigation';

module.exports = {
  path: MAIN_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/MainApp'));
    });
  },
  getChildRoutes(partialNextState, cb) {
    require.ensure([], (require) => {
      cb(null, [
        require('./routes/contact_us'),
        require('./routes/faq'),
        require('./routes/how_it_works'),
        require('./routes/terms_of_service'),
      ]);
    });
  },
};



// WEBPACK FOOTER //
// ./routes/more/index.js